import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "onClick"]
const _hoisted_2 = { class: "u-label" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "u-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["z-radio ztn-page-t300", [_ctx.sizeClass, {'z-radio-button-solid': _ctx.buttonType === 'solid'}]]),
    style: _normalizeStyle(_ctx.radioStyle)
  }, [
    (!_ctx.button)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["z-radio-wrap", {'vertical': _ctx.vertical}]),
            style: _normalizeStyle(_ctx.sum !== index + 1 ? _ctx.styleObject: ''),
            key: index
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["m-box", {'z-radio-disabled': _ctx.disabled || option.disabled}]),
              id: 'range_' + option.value,
              onClick: ($event: any) => ((_ctx.disabled || option.disabled) ? () => false : _ctx.onClick(option.value))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["u-radio", {'u-radio-checked': _ctx.value === option.value }])
              }, null, 2),
              _createElementVNode("span", _hoisted_2, [
                _renderSlot(_ctx.$slots, "default", {
                  label: option.label
                }, () => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ], true)
              ])
            ], 10, _hoisted_1)
          ], 6))
        }), 128))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["z-radio-button-wrap", {
          'z-radio-button-checked': _ctx.value === option.value,
          'z-radio-button-disabled': _ctx.disabled || option.disabled,
        }]),
            key: index,
            onClick: ($event: any) => ((_ctx.disabled || option.disabled) ? () => false : _ctx.onClick(option.value))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default", {
                label: option.label
              }, () => [
                _createTextVNode(_toDisplayString(option.label), 1)
              ], true)
            ])
          ], 10, _hoisted_3))
        }), 128))
  ], 6))
}